import angular from 'angular'

angular.module('pub.top_prizes.service', []).factory('TopPrizeService', TopPrizeService)

/** @ngInject */
function TopPrizeService($http, $q, API) {
  function list(start, limit) {
    var defered = $q.defer()

    $http
      .get(API.API_URL + 'publisher/top_prizes?start=' + start + '&limit=' + limit + '&sort=n-asc')
      .success(defered.resolve)

    return defered.promise
  }

  function listUnpublishedBychannel(chId, start, limit) {
    var defered = $q.defer()

    $http
      .get(
        API.API_URL +
          'publisher/channels/' +
          chId +
          '/top_prizes/unpublished?start=' +
          start +
          '&limit=' +
          limit +
          '&sort=n-asc',
      )
      .success(defered.resolve)

    return defered.promise
  }

  function listPublishedBychannel(chId, start, limit) {
    var defered = $q.defer()

    $http
      .get(
        API.API_URL +
          'publisher/channels/' +
          chId +
          '/top_prizes/published?start=' +
          start +
          '&limit=' +
          limit +
          '&sort=n-asc',
      )
      .success(defered.resolve)

    return defered.promise
  }

  function listExpiredBychannel(chId, start, limit) {
    var defered = $q.defer()

    $http
      .get(
        API.API_URL +
          'publisher/channels/' +
          chId +
          '/top_prizes/expired?start=' +
          start +
          '&limit=' +
          limit +
          '&sort=n-asc',
      )
      .success(defered.resolve)

    return defered.promise
  }

  function get(id) {
    var defered = $q.defer()

    $http.get(API.API_URL + 'publisher/top_prizes/' + id).success(defered.resolve)

    return defered.promise
  }

  function save(model) {
    var defered = $q.defer()

    $http
      .post(API.API_URL + 'publisher/top_prizes', model)
      .success(defered.resolve)
      .error(defered.reject)

    return defered.promise
  }

  function update(id, model) {
    var defered = $q.defer()

    $http
      .put(API.API_URL + 'publisher/top_prizes/' + id, model)
      .success(defered.resolve)
      .error(defered.reject)

    return defered.promise
  }

  function remove(id) {
    var defered = $q.defer()

    $http
      .delete(API.API_URL + 'publisher/top_prizes/' + id)
      .success(defered.resolve)
      .error(defered.reject)

    return defered.promise
  }

  return {
    list: list,
    listUnpublishedBychannel,
    listPublishedBychannel,
    listExpiredBychannel,
    get: get,
    save: save,
    update: update,
    remove: remove,
  }
}
